

import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
 import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { VolunteeringExperiencesFormComponent } from './volunteering-experiences-form/volunteering-experiences-form.component';
import { AmbassadorsProfileService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/ambassadors-profile.service';
import { ConnectLookupsService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/connectLookups.service';
import { AmbassadorVolunteeringExperience } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/models/AmbassadorVolunteeringExperience';
 @Component({
  selector: 'app-volunteering-experiences',
  standalone: false,
  templateUrl: './volunteering-experiences.component.html'
})
export class VolunteeringExperiencesComponent implements OnInit {
  @Input() userId!:any;
  @Input() canModify!:boolean;
  formGroup!: FormGroup;
  showModal = false
  dataLoading = false
  dataSource: AmbassadorVolunteeringExperience[] = []

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private service: AmbassadorsProfileService,
    private lookupsService: ConnectLookupsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getAll()
  }


  getAll() {
    this.dataLoading = true;
    const params = this.userId ? { userId: this.userId } : {};
    this.service.GetAmbassadorVolunteeringExperience(params).subscribe((response: any) => {
      this.dataLoading = false;
      this.dataSource = response as AmbassadorVolunteeringExperience[];
    }, err => {
      this.dataLoading = false
    })
  }

  openForm(record: any = null) {
    const dialogRef = this.dialog.open(VolunteeringExperiencesFormComponent, {
      width: '550px',
      data: { record },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAll();
      }
    });

  }


  deleteRecord(id: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.service.DeleteAmbassadorVolunteeringExperience(id).subscribe(
          (data: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.deletededsuccessfuly'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            });
            this.getAll();
          }, (error: any) => {
            console.error(error);
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: this.translate.instant('swalMsg.FailedText'),
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            });
          });
      }
    });
  }


}

